module.exports = __webpack_public_path__ + "static/zalacznik-nr-1-umowa-powierzenia-fakturomania.de6715b6.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/universal/docs/zalacznik-nr-1-umowa-powierzenia-fakturomania.pdf
// module id = 489
// module chunks = 168707334958949